var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.622 12.863-2.609 4.523-2.609 4.523-2.612 4.513-2.609-4.52 2.609-4.523 2.611-4.52L11.442 6h5.216l1.355 2.342 2.608 4.52zM6.22 6H1l6.572 11.382 2.611-4.52L6.221 6zm22.172 2.342L27.038 6H21.82l3.963 6.863-2.612 4.523-2.608 4.523 2.609 4.513 2.613-4.52 2.609-4.523L31 12.86l-2.608-4.518z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWing);
export default __webpack_public_path__ + "static/media/WING.9e0c997ef67a72e82c1a9c29bd5670ca.svg";
export { ForwardRef as ReactComponent };